import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import 'reactflow/dist/style.css';
import './fonts.css';
import './responsive-zoom.css';

import './i18n';
import App from './App';
import theme from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import { ApiProvider } from './contexts/ApiContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { BellNotificationProvider } from './contexts/BellNotificationContext';
import { SoftphoneProvider } from './contexts/SoftphoneContext';
import { AgentProvider } from './contexts/AgentContext';
import { PluginProvider } from './plugins/PluginContext';
import { WhatsAppCallProvider } from './hooks/useWhatsAppCall';

if (typeof window !== 'undefined') {
  const frontendTrace = {
    app: 'enigmapbx',
    mode: process.env.NODE_ENV,
    loadedAt: new Date().toISOString()
  };
  window.__FRONTEND_TRACE = frontendTrace;
  console.warn('[FRONTEND TRACE] index.js loaded', frontendTrace);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <ApiProvider>
            <BellNotificationProvider>
              <NotificationProvider>
                <AgentProvider>
                  <SoftphoneProvider>
                    <WhatsAppCallProvider>
                      <PluginProvider>
                        <App />
                      </PluginProvider>
                    </WhatsAppCallProvider>
                  </SoftphoneProvider>
                </AgentProvider>
              </NotificationProvider>
            </BellNotificationProvider>
          </ApiProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
